import React from 'react';
import { twMerge } from 'tailwind-merge';

export interface ButtonProps {
  id?: string;
  type?: 'submit' | 'reset' | 'button';
  disabled?: boolean;
  className?: string;
  icon?: React.ReactNode;
  children: React.ReactNode;
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
}

export const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
  function (
    {
      id,
      disabled = false,
      children,
      icon,
      className,
      type = 'button',
      onClick = () => {},
    },
    ref
  ) {
    const classNames = twMerge(
      'fontMontserrat flex flex-row justify-center items-center gap-2 bg-[#2E5BFF] text-white font-bold py-2 px-2 rounded box-border text-sm font-normal',
      disabled ? 'cursor-not-allowed bg-[#9EABCA]' : 'hover:bg-[#2d4fd7]',
      className
    );

    const handleClick = disabled ? () => {} : onClick;

    return (
      <button
        ref={ref}
        id={id}
        type={type}
        className={classNames}
        onClick={handleClick}
      >
        {icon ? icon : null}
        <span>{children}</span>
      </button>
    );
  }
);

export default Button;
